import { Button } from '@qodo/design-system';
import { useConversionPopup } from 'hooks/billing/useConversionPopup';
import type { ButtonProps } from '@qodo/design-system';
import type { ConversionPopupTriggerSource } from 'services/mixpanel/types';

type ConversionPopupButtonProps = Omit<ButtonProps, 'onClick'> & {
  triggerSource: ConversionPopupTriggerSource;
};

/** Button that opens the conversion popup. Owns the hook call so callers need no onClick wiring. */
export const ConversionPopupButton = ({
  triggerSource,
  ...props
}: ConversionPopupButtonProps) => {
  const { open } = useConversionPopup();

  return <Button {...props} onClick={() => open(undefined, triggerSource)} />;
};
